import { combineReducers } from 'redux'
import MyMedicAppReducer from './mymedic.app.reducer'
import MyMedicTMReducer from './mymedic.tm.reducer'

const MyMedicReducer = combineReducers({
  app: MyMedicAppReducer,
  tm: MyMedicTMReducer,
})

export default MyMedicReducer